import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "./footer.scss"; 

const Footer = () => {
  const navigate = useNavigate(); // Inisialisasi useNavigate

  const handleLoginNavigate = () => {
    navigate("/login");
  };

  return (
    // Wrapper utama untuk footer
    <footer className="footer-wrap">
      {/* Bagian Putih (Informasi Gereja) */}
      <div className="footer-top">
        <p className="main-title">Gereja Masehi Injili di Minahasa</p>
        <p className="sub-title">Jemaat Genesaret Pateten</p>
      </div>

      {/* Bagian Abu-abu Gelap (Informasi Copyright & Developer + Tombol Login) */}
      <div className="footer-bottom">
        <p className="copyright">AldioCK &copy;{new Date().getFullYear()}</p>
               <p className="developer">Admin & Web Developer</p>
        
        {/* Tombol Login yang tidak mencolok */}
        <span 
          className="footer-login-link" 
          onClick={handleLoginNavigate}
        >
          Login Admin
        </span>

 
      </div>
    </footer>
  );
};

export default Footer;